import React, { Component } from "react";
import Header from "../header_h/Header";
import Footer from "../footer/Footer";
import BreadcrumbsModulePage from "../breadcrumbs/BreadcrumbsModulePage";
import SelectionContainer from "../selection_container/SelectionContainer.js";
import ModuleContainer from "../module-container/ModuleContainer";
import ExportPdfButton from "./ExportPdfButton.js";
import { QUESTION_KIND, resolveQuestionKind } from "./runtime/questionKinds";

function matchesSelection(selectionType, question) {
  const kind = resolveQuestionKind(question);

  if (selectionType === "test") {
    return kind === QUESTION_KIND.TEST;
  }

  if (selectionType === "interactive") {
    return kind === QUESTION_KIND.DROPDOWN || kind === QUESTION_KIND.DND;
  }

  if (selectionType === "video") {
    return kind === QUESTION_KIND.VIDEO;
  }

  return false;
}

class ModulePage extends Component {
  state = {
    selectedType: null,
    filteredModule: null,
  };

  componentDidUpdate(prevProps) {
    const prevTitle = prevProps?.module?.title;
    const nextTitle = this.props?.module?.title;

    if (prevTitle !== nextTitle) {
      this.setState({
        selectedType: null,
        filteredModule: null,
      });
    }
  }

  handleSelect = (type) => {
    const { module } = this.props;
    const questions = Array.isArray(module?.questions) ? module.questions : [];

    const filteredQuestions = questions.filter((question) =>
      matchesSelection(type, question)
    );

    const filteredModule = {
      ...module,
      questions: filteredQuestions,
    };

    this.setState({ selectedType: type, filteredModule });
  };

  render() {
    const { userName, userRoles, module, path } = this.props;
    const { component: Component } = this.props;
    const { selectedType, filteredModule } = this.state;

    const isAvrRoute = window.location.pathname.includes("/avr/");

    if (!isAvrRoute) {
      return (
        <>
          <Header userName={userName} userRoles={userRoles} />
          <BreadcrumbsModulePage moduleTitle={module?.title} />
          {Array.isArray(userRoles) && userRoles.includes("ADMIN") && (
            <ExportPdfButton module={module} />
          )}
          <ModuleContainer component={Component} module={module} path={path} />
          <Footer />
        </>
      );
    }

    return (
      <>
        <Header userName={userName} userRoles={userRoles} />
        <BreadcrumbsModulePage />
        {Array.isArray(userRoles) && userRoles.includes("ADMIN") && (
          <ExportPdfButton module={module} />
        )}

        {!selectedType ? (
          <SelectionContainer onSelect={this.handleSelect} />
        ) : filteredModule && filteredModule.questions.length > 0 ? (
          <ModuleContainer
            component={Component}
            module={filteredModule}
            path={path}
          />
        ) : (
          <div className="placeholder-content">
            <p>Для даної теми завдання не призначено</p>
          </div>
        )}
        <Footer />
      </>
    );
  }
}

export default ModulePage;
